export const clientsUrl = 'clients/';
export const clientOptionsUrl = `${clientsUrl}options/`;
export const clientSummaryUrl = `${clientsUrl}summary/`;
export const clientFilterOptionsUrl = `${clientsUrl}filter-options/`;
export const clientAutocompleteUrl = `${clientsUrl}autocomplete/`;
export const clientGroupAutocompleteUrl = `${clientsUrl}groups/autocomplete/`;
export const clientCompetitorsUrl = `${clientsUrl}groups/competitors/`;
export const clientGroupNameTakenUrl = `${clientsUrl}groups/name-taken/`;
export const clientCompanyNamesUrl = `${clientsUrl}company-names/`;
export const clientAddressSearchUrl = `${clientsUrl}address-search/`;
export const clientMatchesUrl = `${clientsUrl}matches/`;
export const clientInternalNameUrl = `${clientsUrl}internal-name/`;
export const clientContactsUrl = `${clientsUrl}contacts/`;
export const clientContactSummaryUrl = `${clientContactsUrl}summary/`;
export const clientContactFilterOptionsUrl = `${clientContactsUrl}filter-options/`;
export const clientContactMatchesUrl = `${clientContactsUrl}matches/`;
export const businessSegmentsUrl = `${clientsUrl}choices/business-segments/`;

export function clientUrl(id: number | string): string {
  return `${clientsUrl}${String(id)}/`;
}

export function clientContactUrl(id: number | string): string {
  return `${clientContactsUrl}${String(id)}/`;
}

export function clientGroupUrl(id: number | string): string {
  return `${clientsUrl}groups/${String(id)}/`;
}

export const clientHistoryUrl = `${clientsUrl}history/`;
export const clientHistoryFilterOptionsUrl = `${clientHistoryUrl}filter-options/`;
export const clientHistoryContactOptionsUrl = `${clientHistoryUrl}contact-options/`;

export function clientHistoryItemUrl(id: number | string): string {
  return `${clientHistoryUrl}${String(id)}/`;
}
